import { Tooltip } from '@material-ui/core';
import { tooltip } from '../const';

export default function ProductTooltip() {
  return (
    <Tooltip
      title={
        <span
          style={{
            color: 'white',
            fontSize: '12px',
          }}
        >
          {tooltip.title}
        </span>
      }
    >
      <span style={{ fontSize: '12px' }} className="material-icons">
        {tooltip.text}
      </span>
    </Tooltip>
  );
}
